import { filterTree, traverseTree } from "@/utils/tree";
import { getDictTableData } from "@/pages/documentCompile/dict/utils";
import { DictTemplateCodeEnum } from "@/pages/documentCompile/dict/type";
import { getDomainTableData } from "@/pages/documentCompile/domain/utils";
import { FieldType } from "@/pages/documentCompile/type";
import { getArrayFromArrayString } from "@/utils/arr";
import dayjs from "dayjs";

export const getDomainTreeDataByDict = (domainData: any, resProjectDictData: any) => {
    const expandedKeys = ['all', 'project']
    traverseTree(domainData, (node) => {
        if (node.fieldName) {
            node.title = node.fieldName
        }
        if (node.dictName) {
            node.title = node.dictName
        }
        if (node.fieldTag) {
            node.key = node.fieldTag
            node.fieldTag = node.fieldTag
            node.isDomain = true
        }
        if (node.groupName) {
            node.title = node.groupName
            node.key = node.id
            node.noField = true // 组域不显示字段
        }

        // 字段域
        if (node.attr_zdlx) {
            node.fieldType = node.attr_zdlx
        }
        if (typeof node.content === 'string') {
            node.content = JSON.parse(node.content)
        }
    })
    const newDomainData = filterTree(domainData, (node) => {
        return node.fieldTag && node.isEnabled
    })
    // console.log("newDomainData", newDomainData);
    resProjectDictData.sort((a, b) => a.sort - b.sort)
    const projectDictData = resProjectDictData.map(item => {
        const fieldType = item['attr_zdlx']
        let content = {}
        if ([FieldType.DROPDOWN, FieldType.SINGLE_CHECKBOX, FieldType.CHECKBOX].includes(fieldType)) {
            content = {
                options: item.attr_nr || []
            }
        }
        return {
            ...item,
            key: item.dictCode,
            title: item.dictName,
            fieldName: item.dictName,
            fieldTag: item.dictCode,
            fieldType: item['attr_zdlx'],
            content,
            // value: item.value,
        }
    })
    // console.log("projectDictData", projectDictData);
    const projectDictNode = {
        key: 'project',
        title: '项目信息',
        noField: true,
        children: projectDictData
    }
    const rootNode = [{
        key: 'all',
        title: '全部字段域',
        noField: true,
        children: []
    }]
    rootNode[0].children.push(projectDictNode)
    newDomainData.forEach(item => {
        rootNode[0].children.push(item)
        expandedKeys.push(item.key)
    })
    return [rootNode, expandedKeys]
}

// 获取模板域字段
export const getTemplateDomainTreeData = async () => {
    const promiseList = [getDomainTableData(), getDictTableData(DictTemplateCodeEnum.PROJECT_ATTR)]
    const [domainData, resProjectDictData] = await Promise.all(promiseList)
    return getDomainTreeDataByDict(domainData, resProjectDictData)
}


// 过滤listFieldByDoc 返回的数据
export const filterListFieldByDoc = (listFieldByDocRes: any[]) => {
    const newListFieldByDocRes = listFieldByDocRes.map(item => {
        return {
            ...item,
            fieldValue: getArrayFromArrayString(item.fieldValue, { needNumber: true })
        }
    })
    return newListFieldByDocRes
}

// 处理接口返回的数据，返回 form 需要的数据，纠正"[]" 为 []
export const getAntdFormDataByRes = (datas: any) => {
    datas.forEach(data => {
        let tempValue = getArrayFromArrayString(data.fieldValue, { needNumber: true }) as any
        if (dayjs.isDayjs(tempValue)) {
            tempValue = tempValue.valueOf()
        }
        data.fieldValue = tempValue
    })
    return datas
}